export default [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'devicCode',
    key: 'deviceCode',
    width: 200
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 230
  },
  {
    zh: '排气压力(MPa)',
    en: 'Exhaust Pressure(MPa)',
    dataIndex: 'exhaustPressure',
    key: 'exhaustPressure'
  },
  {
    zh: '油分桶压力(MPa)',
    en: 'Oil Drum Pressure(MPa)',
    dataIndex: 'oilDrumPressure',
    key: 'oilDrumPressure'
  },
  {
    zh: '输出电流(A)',
    en: 'Output Current(A)',
    dataIndex: 'outputCurrent',
    key: 'outputCurrent'
  },
  {
    zh: '频率(Hz)',
    en: 'Output Frequency(Hz)',
    dataIndex: 'outputFrequency',
    key: 'outputFrequency'
  },
  {
    zh: '上限频率(Hz)',
    en: 'Rated Frequency(Hz)',
    dataIndex: 'ratedFrequency',
    key: 'ratedFrequency'
  },
  {
    zh: '占比',
    en: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage'
  }
]